module.exports = __webpack_public_path__ + "static/media/Agri-food_contract_manufacturing_challenges-removebg-preview.657bac0c.png";